<template>
  <div> 
    <HomePage></HomePage>
  </div>
</template>

<script> 
import HomePage from "@/views/homePage/index.vue"
export default {
  components: { 
    HomePage
  }
}
</script>

<style lang="scss" scoped></style>